import React from 'react';
import { Badge } from './ui/badge';
import { STATUS_CONFIG } from './StatusChart';

function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['pending'];
  
  return (
    <Badge
      className="font-medium capitalize"
      style={{
        backgroundColor: config.bgColor,
        color: config.color,
        borderColor: config.color,
        border: '1px solid'
      }}
    >
      {config.label}
    </Badge>
  );
}

export default StatusBadge;